import React, {CSSProperties, MouseEvent, ReactNode} from 'react';
import {classes, stylesheet} from 'typestyle';
import {observer} from 'mobx-react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import onClickOutside from 'react-onclickoutside';
import {GreyBlueBackgroundColor, WhiteColor, GreyColor} from '../../styles/colors';

interface FoldoutProps {
    leftPosition?: number;
    rightPosition?: number;
    bottomPosition?: number;
    topPosition?: number;
    minWidth?: number;
    maxWidth?: number;
    arrowLeftPosition?: number;
    arrowRightPosition?: number;
    title: ReactNode;
    body: ReactNode;
    onClose: () => void;
}

@observer
class Foldout extends React.Component<FoldoutProps> {
    // Handler for react-onclickoutside
    public handleClickOutside = (event: MouseEvent<HTMLElement>): void => {
        this.props.onClose();
    };

    public render() {
        const {
            leftPosition,
            rightPosition,
            bottomPosition,
            topPosition,
            minWidth,
            maxWidth,
            arrowLeftPosition,
            arrowRightPosition,
            title,
            body,
            onClose,
        } = this.props;

        const style: CSSProperties = {
            left: leftPosition,
            right: rightPosition,
            bottom: topPosition === undefined ? (bottomPosition === undefined ? 0 : bottomPosition) : undefined,
            top: topPosition,
            minWidth,
            maxWidth,
        };

        const arrowStyle: CSSProperties = {
            left: arrowLeftPosition,
            right: arrowRightPosition,
        };

        const arrowBackgroundStyle: CSSProperties = {
            left: arrowLeftPosition === undefined ? undefined : arrowLeftPosition - 1,
            right: arrowRightPosition === undefined ? undefined : arrowRightPosition - 1,
        };

        return (
            <div className={bubbleCss.Foldout}>
                <div className={bubbleCss.box} style={style}>
                    <div
                        className={classes(
                            bubbleCss.arrow,
                            bubbleCss.arrowBackground,
                            topPosition === undefined ? undefined : bubbleCss.topArrow,
                            topPosition === undefined ? undefined : bubbleCss.topArrowBackground
                        )}
                        style={arrowBackgroundStyle}
                    />
                    <div className={classes(bubbleCss.arrow, topPosition === undefined ? undefined : bubbleCss.topArrow)} style={arrowStyle} />
                    <div className={bubbleCss.titleBar}>
                        {title}
                        <div className={bubbleCss.closer} onClick={onClose}>
                            <FontAwesomeIcon icon="times" />
                        </div>
                    </div>
                    {body}
                </div>
            </div>
        );
    }
}

export default onClickOutside(Foldout);

const bubbleCss = stylesheet({
    Foldout: {
        position: 'absolute',
    },
    titleBar: {
        backgroundColor: GreyBlueBackgroundColor,
        margin: '-10px -10px 10px -10px',
        padding: '4px 10px',
        borderTopLeftRadius: 4,
        borderTopRightRadius: 4,
        display: 'flex',
        justifyContent: 'space-between',
    },
    closer: {
        float: 'right',
        cursor: 'pointer',
    },
    box: {
        position: 'absolute',
        zIndex: 200,
        backgroundColor: WhiteColor,
        padding: 10,
        border: '1px solid ' + GreyColor,
        borderRadius: 4,
    },
    arrow: {
        top: '100%',
        border: 'solid transparent',
        height: 0,
        width: 0,
        position: 'absolute',
        pointerEvents: 'none',
        borderTopColor: WhiteColor,
        borderWidth: 10,
    },
    arrowBackground: {
        borderTopColor: GreyColor,
        borderWidth: 11,
        transform: 'translateY(0.5px)',
    },
    topArrow: {
        top: -20,
        borderBottomColor: WhiteColor,
        borderTopColor: 'transparent',
    },
    topArrowBackground: {
        top: -23,
        borderBottomColor: GreyColor,
        borderTopColor: 'transparent',
    },
});



// WEBPACK FOOTER //
// ./src/views/Table/Foldout.tsx